"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSelectGameBetLinesDenomCtl = /** @class */ (function (_super) {
    __extends(DlgSelectGameBetLinesDenomCtl, _super);
    function DlgSelectGameBetLinesDenomCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectGameBetLinesDenomCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            lineNum: 0,
            linesAvail: [],
            betVal: 0,
            betsAvail: [],
            dnmVal: 0,
            dnmsAvail: [],
            onNo: null
        };
    };
    DlgSelectGameBetLinesDenomCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetBets = function (bets, forceUpdate) {
        this.DATA.betsAvail = bets;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetBets = function () {
        return this.DATA.betsAvail;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetBetVal = function (BetVal, forceUpdate) {
        this.DATA.betVal = BetVal;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetBetVal = function () {
        return this.DATA.betVal;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetDnms = function (dnms, forceUpdate) {
        this.DATA.dnmsAvail = dnms;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetDnms = function () {
        return this.DATA.dnmsAvail;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetDnmVal = function (DnmVal, forceUpdate) {
        this.DATA.dnmVal = DnmVal;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetDnmVal = function () {
        return this.DATA.dnmVal;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetLines = function (lines, forceUpdate) {
        this.DATA.linesAvail = lines;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetLines = function () {
        return this.DATA.linesAvail;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.SetLineNum = function (LineNum, forceUpdate) {
        this.DATA.lineNum = LineNum;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSelectGameBetLinesDenomCtl.prototype.GetLineNum = function () {
        return this.DATA.lineNum;
    };
    return DlgSelectGameBetLinesDenomCtl;
}(BaseController_1.BaseController));
exports.DlgSelectGameBetLinesDenomCtl = DlgSelectGameBetLinesDenomCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSelectGameBetLinesDenomCtl.ts
// module id = 908
// module chunks = 0